import { Tool } from '../../types';

export const videoTools: Tool[] = [
  {
    id: 'obs-studio',
    name: 'OBS Studio',
    category: 'Video & Streaming',
    description: 'Free, open-source software for video recording and live streaming to platforms like YouTube, Twitch, and Facebook. Features scene composition, audio mixing, and real-time video capture. The go-to choice for streamers and content creators.',
    pricing: ['free'],
    features: ['ease-of-use', 'integrations'],
    bestFor: ['content-creator', 'freelancer'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['creative', 'marketing', 'education'],
    website: 'https://obsproject.com',
    imageUrl: 'https://logo.clearbit.com/obsproject.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'streamlabs',
    name: 'Streamlabs',
    category: 'Video & Streaming',
    description: 'All-in-one streaming platform that combines broadcasting, alerts, donations, and widgets. Built-in themes, chat management, and monetization tools help creators grow their audience and revenue. Trusted by millions of streamers worldwide.',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'integrations', 'mobile'],
    bestFor: ['content-creator', 'freelancer'],
    compatibleWith: ['content-creator'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['creative', 'marketing'],
    website: 'https://streamlabs.com',
    imageUrl: 'https://logo.clearbit.com/streamlabs.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'vimeo',
    name: 'Vimeo',
    category: 'Video & Streaming',
    description: 'Professional video hosting platform for businesses and creators who demand quality. Ad-free viewing, advanced privacy controls, detailed analytics, and live streaming. Includes collaboration tools, video editing, and embeddable players.',
    pricing: ['free', 'medium', 'high'],
    features: ['integrations', 'mobile', 'security'],
    bestFor: ['small-business', 'content-creator'],
    compatibleWith: ['agency', 'content-creator'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['creative', 'marketing', 'education'],
    website: 'https://vimeo.com',
    imageUrl: 'https://logo.clearbit.com/vimeo.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];